import React from "react";
import { useI18n } from "../../i18n/LanguageContext";

// Imagen de una carta/menú que cambia según el idioma activo. Usa la versión
// del idioma actual (en, ja…) si existe; si no, o si esa imagen aún no está
// subida (404), cae automáticamente a la española gracias a onError. Así nunca
// se ve una imagen rota aunque falte alguna traducción.
export default function MenuImage({ es, en, ja, className, alt, width, height }) {
  const { lang } = useI18n();
  const porIdioma = { en, ja };
  const initial = porIdioma[lang] || es;

  return (
    <img
      loading="lazy"
      decoding="async"
      width={width}
      height={height}
      className={className}
      src={initial}
      alt={alt}
      onError={(e) => {
        if (e.currentTarget.getAttribute("src") !== es) {
          e.currentTarget.src = es;
        }
      }}
    />
  );
}
